import React from 'react';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import PossibleAnswer from "./PossibleAnswer";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as FormActionCreator from "../../../redux/creators/form";
import { translate } from "../../base/Translation";

class PossibleAnswers extends React.Component {

	componentDidMount() {
		this.shouldUpdate = false;
	}

	addAnswer() {
		this.shouldUpdate = true;

		this.props.addAnswer({
			id: -Math.random(),
			name: "",
			other: 0,
			points: 0
		}, this.props.section, this.props.group, this.props.question);
	}

	render() {

		this.shouldUpdate = false;

		let answers = this.props.possible_answers.map(function (answer) {
			return (
				<PossibleAnswer key={answer.id}
					answer={answer}
					section={this.props.section}
					group={this.props.group}
					question={this.props.question}
					updateAnswer={this.props.updateAnswer}
				/>
			);
		}.bind(this));

		return (
			<div>
				<Row>
					<Col lg={6}>
						<ControlLabel className="visible-lg">{translate("Odpoveď")}</ControlLabel>
					</Col>
					<Col lg={2}>
						<ControlLabel className="visible-lg">{translate("Body")}</ControlLabel>
					</Col>
					<Col lg={2}>
						<ControlLabel className="visible-lg">{translate("Iné")}</ControlLabel>
					</Col>
					<Col lg={2}>
						<ControlLabel className="visible-lg">{translate("Možnosti")}</ControlLabel>
					</Col>
				</Row>
				{answers}
				<Row>
					<Col lg={12}>
						<button className="btn btn-primary btn-sm" onClick={this.addAnswer.bind(this)}>{translate("Pridať odpoveď")}</button>
					</Col>
				</Row>
			</div>
		)
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ addAnswer: FormActionCreator.addAnswerAction, updateAnswer: FormActionCreator.updateAnswerAction }, dispatch);
}

export default connect(state => ({ form: state.form }), matchDispatchToProps)(PossibleAnswers);


// WEBPACK FOOTER //
// ./src/modules/form/edit/PossibleAnswers.js